import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import SupplierService from "../../../Supplier/Controller/SupplierController";
import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import PurchaseOrderService from "../../Controller/PurchaseOrderController";
import { convertCurrency } from "./CurrencyConverter";
export const DeliverPurchase = (selectedId) => {
    const navigate = useNavigate();
    const fetchPurchaseOrderDetail = async (selectedId) => {
        try {
            const redirectCallback = () => navigate('/');

            if (selectedId > 0) {
                const purchaseOrderDetail = await PurchaseOrderService.GetPurchaseOrderByID(redirectCallback, selectedId);
                const purchaseOrder = purchaseOrderDetail[0];
                return purchaseOrder;
            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };

    const fetchPurchaseOrderItems = async (selectedId) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            if (selectedId > 0) {
                const saleOrderDetails = await PurchaseOrderService.GetPurchaseOrderItem(redirectCallback, selectedId);

                const purchaseOrderDetail = await PurchaseOrderService.GetPurchaseOrderByID(redirectCallback, selectedId);
                const purchaseOrder = purchaseOrderDetail[0];
                const lisoffSuppliers = await SupplierService.GetAllSuppliers(redirectCallback);
                const selectedSupplier = lisoffSuppliers.find(supplier => supplier.PK_Supplier_ID === parseInt(purchaseOrder.FK_Supplier_ID));
                const currencyData = await CurrencyService.GetAllCurrencies(redirectCallback);
                const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
                let ConversionRate = await convertCurrency(listOfCurreny[0].Symbol, selectedSupplier.vc_CurrencySymbol, currencyData, "0");
                ConversionRate = "1";

                const selectedPartsData = await Promise.all(saleOrderDetails.map(async (detail) => {
                    const convertedStockPrice = (detail.mon_StockPrice * ConversionRate)
                    const convertedmon_SalesPrice = (detail.mon_SalesPrice * ConversionRate);
                    const convertedvc_UnitOfSale = (detail.vc_UnitOfSale * ConversionRate);
                    const convertednet_SalesPrice = (detail.net_SalesPrice * ConversionRate);
                    const converteddetailnet_VATPrice = (detail.net_VATPrice * ConversionRate);
                    const convertedmon_SellingPrice = (detail.mon_SellingPrice * ConversionRate);

                    return {
                        vc_StockCode: detail.vc_StockCode,
                        PK_PurchaseOrderItem_ID: detail.PK_PurchaseOrderItem_ID,
                        vc_Description: detail.vc_Description,
                        mon_StockPrice: convertedStockPrice, // Use the converted price
                        mon_SalesPrice: convertedmon_SalesPrice,
                        vc_UnitOfSale: parseFloat(convertedvc_UnitOfSale) - parseFloat(detail.dec_Delivered ?? 0),
                        net_SalesPrice: convertednet_SalesPrice,
                        net_VATPrice: converteddetailnet_VATPrice,
                        vc_StockName: detail.vc_Description,
                        PK_Stock_ID: detail.FK_Stock_ID,
                        dec_Discount: detail.dec_Discount,
                        mon_SellingPrice: convertedmon_SellingPrice,
                        dec_Delivered: detail.dec_Delivered,
                        dec_OnOrder: detail.dec_OnOrder,
                        FK_Location_ID_Stock: detail.FK_Location_ID_Stock,
                        vc_Name: detail.vc_Name,
                        vc_SerialFormat: detail.vc_SerialFormat,
                        snt_SerialTracking: detail.snt_SerialTracking ?? 0,
                        bit_BatchManagement: detail.bit_BatchManagement ?? 0,
                        vc_BatchNumber: "",
                        vc_SerialPrefix:detail.vc_SerialPrefix
                        // Map other fields as needed
                    };
                }));

                return selectedPartsData;
            }
        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };

    const handleDeliverPurchase = async (event, ID) => {
        event.stopPropagation();


        try {
            const redirectCallback = () => navigate('/');
            const lisoffSuppliers = await SupplierService.GetAllSuppliers(redirectCallback);
            const purchaseOrderDetail = await fetchPurchaseOrderDetail(ID);
            const selectedSupplier = lisoffSuppliers.find(supplier => supplier.PK_Supplier_ID === parseInt(purchaseOrderDetail.FK_Supplier_ID));
            const currencyData = await CurrencyService.GetAllCurrencies(redirectCallback);
            const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
            const ConversionRate = await convertCurrency(listOfCurreny[0].Symbol, selectedSupplier.vc_CurrencySymbol, currencyData, "0");
            const PurchaseOrderItemsList = await fetchPurchaseOrderItems(ID, selectedSupplier.vc_CurrencySymbol, ConversionRate);
            return PurchaseOrderItemsList;

        } catch (error) {
            console.error("Error during purchase order process:", error);
        }
    }


    return { handleDeliverPurchase };
};
export default DeliverPurchase;